module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./install.md");


//////////////////
// WEBPACK FOOTER
// ./examples/docs/install.md
// module id = 0HBL
// module chunks = 1